//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//
import produce, { Draft } from 'immer';

import AppConstants from 'utils/AppConstants';

import {
  PicklistsActionType,
  PicklistsState,
  GET_PICKLIST_VALUES_PENDING,
  GET_PICKLIST_VALUES_FULFILLED,
  GET_PICKLIST_VALUES_FAILED,
  FETCH_PICKLIST_VALUES_BATCH_PENDING,
  FETCH_PICKLIST_VALUES_BATCH_COMPLETE,
  INVALIDATE_PICKLIST_VALUES,
} from './types';

const { FETCH_STATUS } = AppConstants;

export function _getDefaultState() {
  return {
    fetchingPicklistValues: false,
    picklistValues: {},
    fetchingPicklistValuesStatus: {},
    isFetchingBatch: false,
  };
}

const reducer = produce((draft: Draft<PicklistsState>, action: PicklistsActionType) => {
  switch (action.type) {
    case GET_PICKLIST_VALUES_PENDING:
      draft.fetchingPicklistValues = true;
      break;
    case GET_PICKLIST_VALUES_FULFILLED:
      draft.fetchingPicklistValues = false;
      draft[action.key] = action.pickListValues;
      break;
    case GET_PICKLIST_VALUES_FAILED:
      draft.fetchingPicklistValues = false;
      break;
    case FETCH_PICKLIST_VALUES_BATCH_PENDING:
      draft.isFetchingBatch = true;
      // Set per-item loading status so consumers can check individual picklist state
      action.ids.forEach((id) => {
        draft.fetchingPicklistValuesStatus[id] = FETCH_STATUS.LOADING;
      });
      break;
    case FETCH_PICKLIST_VALUES_BATCH_COMPLETE: {
      // Apply successes and failures in a single state update
      action.results.forEach((result) => {
        draft.fetchingPicklistValuesStatus[result.id] = FETCH_STATUS.SUCCESS;
        draft.picklistValues[result.id] = result.pickListValues;
      });
      action.errors.forEach((err) => {
        draft.fetchingPicklistValuesStatus[err.id] = FETCH_STATUS.ERROR;
      });
      draft.isFetchingBatch = false;
      break;
    }
    case INVALIDATE_PICKLIST_VALUES:
      draft.picklistValues = {};
      draft.fetchingPicklistValuesStatus = {};
      draft.isFetchingBatch = false;
      break;
    default:
      return draft;
  }
}, _getDefaultState());

export default reducer;
